import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This widget provides state in the form of a single variable.
 * It can be used to connect child widgets together where one widget
 * sets the state and the other reacts to it.
 */
import React from 'react';
import capitalizeFirstLetter from '../../portal/common/capitalizeFirstLetter';
import Renderer from '../Renderer';
const StateHolder = ({ stateName, child, data, context, editData, }) => {
    const [item, setItem] = React.useState();
    const wiredData = { ...data };
    wiredData[stateName] = item;
    wiredData[`set${capitalizeFirstLetter(stateName)}`] = setItem;
    return _jsx(Renderer, { configId: child, data: wiredData, context: context, editData: editData });
};
StateHolder.getChildren = (config) => ([config.props.child]);
StateHolder.meta = {
    group: 'hidden',
    name: 'State Holder',
    description: 'Holds a variable reference for sharing between child components',
    props: [
        {
            key: 'stateName',
            name: 'State Name',
            type: 'text',
            description: 'Name of state variable',
        },
    ],
};
export default StateHolder;
//# sourceMappingURL=StateHolder.js.map